import { useState, useEffect } from 'react';
import { CartProduct, CartService } from '../../../../services';

export const useCart = () => {
  const [isFetchingCart, setIsFetchingCart] = useState(true);
  const [cart, setCart] = useState([] as CartProduct[]);
  const [cartError, setCartError] = useState(undefined);

  const [update, setUpdate] = useState(false);
  const refreshCart = () => setUpdate(!update);

  useEffect(() => {
    const getCart = async () => {
      setIsFetchingCart(true);
      await CartService.getCart()
        .then((currentCart) => {
          setCart(currentCart);
          setIsFetchingCart(false);
        })
        .catch(() => {
          setCartError(CartService.errorMessage);
          setIsFetchingCart(false);
        });
    };

    window.addEventListener(CartService.cartUpdateEvent, refreshCart);
    getCart();

    return () => {
      window.removeEventListener(CartService.cartUpdateEvent, refreshCart);
    };
  }, [update]);

  return {
    cart,
    cartError,
    isFetchingCart,
  };
};
